var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShield = function SvgShield(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87503 3.26995V9.61493C1.87504 11.6205 2.48279 13.5789 3.61816 15.2322C4.75353 16.8853 6.36321 18.1558 8.23503 18.8758L9.10255 19.2091C9.68022 19.4313 10.3198 19.4313 10.8976 19.2091L11.7651 18.8758C13.6369 18.1558 15.2466 16.8853 16.3819 15.2322C17.5173 13.5789 18.1251 11.6205 18.1251 9.61493V3.26995C18.1266 3.03118 18.0592 2.79704 17.9309 2.59568C17.8026 2.39433 17.6188 2.23433 17.4017 2.13495C15.0682 1.11644 12.546 0.602161 10.0001 0.625778C7.45408 0.602161 4.93183 1.11644 2.59836 2.13495C2.38126 2.23433 2.19749 2.39433 2.06918 2.59568C1.94085 2.79704 1.87344 3.03118 1.87503 3.26995Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.875C9.82742 11.875 9.6875 11.7351 9.6875 11.5625C9.6875 11.3899 9.82742 11.25 10 11.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.875C10.1726 11.875 10.3125 11.7351 10.3125 11.5625C10.3125 11.3899 10.1726 11.25 10 11.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.375V5.625",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "shield.5cb24210faac88014971b514efffac59.svg";